"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ButtonWrapper = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const isNil_1 = __importDefault(require("lodash/isNil"));
const Button_1 = __importDefault(require("../Button/Button"));
const constants_1 = require("../../constants");
const Tooltip_1 = __importDefault(require("../Tooltip/Tooltip"));
const ButtonWrapper = (_a) => {
    var { tooltipContent, tooltipPosition, tooltipHideDelay, tooltipShowDelay, tooltipContainerSelector, tooltipMoveBy } = _a, otherProps = __rest(_a, ["tooltipContent", "tooltipPosition", "tooltipHideDelay", "tooltipShowDelay", "tooltipContainerSelector", "tooltipMoveBy"]);
    let button = (0, jsx_runtime_1.jsx)(Button_1.default, Object.assign({}, otherProps));
    if (!(0, isNil_1.default)(tooltipContent)) {
        button = ((0, jsx_runtime_1.jsx)(Tooltip_1.default, Object.assign({ moveBy: tooltipMoveBy, position: tooltipPosition, hideDelay: tooltipHideDelay, showDelay: tooltipShowDelay, content: tooltipContent, showTrigger: [constants_1.HideShowEvent.MOUSE_ENTER], hideTrigger: [constants_1.HideShowEvent.MOUSE_LEAVE], containerSelector: tooltipContainerSelector }, { children: button })));
    }
    return button;
};
exports.ButtonWrapper = ButtonWrapper;
